const attachedRoot = (node) => {
  let currentNode = node;
  if (typeof node.getRootNode !== "function") {
    while (currentNode.parentNode) {
      currentNode = currentNode.parentNode;
    }
    if (currentNode !== document) {
      return null;
    }
    return document;
  }
  const root = currentNode.getRootNode();
  if (root !== document && root.getRootNode({ composed: true }) !== document) {
    return null;
  }
  return root;
};
const defaultConditional = () => true;
const checkEvent = (e, el, binding) => {
  if (!e || !checkIsActive(e, binding)) {
    return false;
  }
  const root = attachedRoot(el);
  if (root instanceof ShadowRoot && root.host === e.target) {
    return false;
  }
  const elements = (typeof binding.value === "object" && binding.value.include || (() => []))();
  elements.push(el);
  return !elements.some((element) => element.contains(e.target));
};
const checkIsActive = (e, binding) => {
  const isActive = typeof binding.value === "object" && binding.value.closeConditional || defaultConditional;
  return isActive(e);
};
const directive = (e, el, binding) => {
  var _a, _b;
  const handler = typeof binding.value === "function" ? binding.value : (_a = binding.value) == null ? void 0 : _a.handler;
  if (((_b = el._clickOutside) == null ? void 0 : _b.lastMousedownWasOutside) === true && checkEvent(e, el, binding)) {
    setTimeout(() => {
      if (checkIsActive(e, binding) && handler) {
        handler(e);
      }
    }, 0);
  }
};
const handleShadow = (el, callback) => {
  const root = attachedRoot(el);
  callback(document.body);
  if (root instanceof ShadowRoot) {
    callback(root);
  }
};
const vClickOutside = {
  inserted(el, binding) {
    const onClick = (e) => {
      directive(e, el, binding);
    };
    const onMousedown = (e) => {
      if (el._clickOutside !== void 0) {
        el._clickOutside.lastMousedownWasOutside = checkEvent(e, el, binding);
      }
    };
    handleShadow(el, (app) => {
      app.addEventListener("click", onClick, true);
      app.addEventListener("mousedown", onMousedown, true);
    });
    el._clickOutside = {
      lastMousedownWasOutside: true,
      onClick,
      onMousedown
    };
  },
  unbind(el) {
    if (!el._clickOutside) {
      return;
    }
    handleShadow(el, (app) => {
      if (!app || !el._clickOutside) {
        return;
      }
      app.removeEventListener("click", el._clickOutside.onClick, true);
      app.removeEventListener("mousedown", el._clickOutside.onMousedown, true);
    });
    delete el._clickOutside;
  }
};

export { attachedRoot, vClickOutside as default, vClickOutside };
